import { useEffect, useState } from "react";
import { BASE_URL, isExternalUrl, REGISTRY_URL } from "@src/utils";

import Section1Img from "./section1Img_new.jpg";
import Section2Img from "./section2Img_new.jpg";
import Section3Img from "./section3Img.png";
import Section4Img from "./section4Img_new.jpg";

import "./springDayBride.scss";
import axios from "@src/api/axios";
import { AxiosResponse } from "axios";

type InvitationInfo = {
  invitationCompletionRate: number;
  shareLink: null | string;
};

export default function SpringDayBride() {
  const [invitationInfo, setInvitationInfo] = useState<InvitationInfo>({
    invitationCompletionRate: 0,
    shareLink: null,
  });
  const handleClickCopyLinkBtn = () => {
    if (invitationInfo.invitationCompletionRate !== 100) {
      const isOk = window.confirm("청첩장이 100% 작성되지 않았습니다. 청첩장을 작성해주세요.");
      if (isOk)
        window.location.href = isExternalUrl(
          `${REGISTRY_URL}/my-wedding/wedding-invitation/customize?hidetop=true`,
        );
    } else {
      navigator.clipboard
        .writeText(invitationInfo.shareLink)
        .then(() => {
          alert("청첩장 링크가 복사되었습니다.");
        })
        .catch(() => {
          "청첩장 링크 복사에 실패하였습니다.";
        });
    }
  };

  const handleClickApplyBtn = () => {
    if (invitationInfo.invitationCompletionRate !== 100) {
      const isOk = window.confirm("청첩장이 100% 작성되지 않았습니다. 청첩장을 작성해주세요.");
      if (isOk)
        window.location.href = isExternalUrl(
          `${REGISTRY_URL}/my-wedding/wedding-invitation/customize?hidetop=true`,
        );
    } else {
      window.location.href = "h2mwbell://webview?url=https://form.typeform.com/to/y3o86bmQ";
    }
  };

  const getInvitationInfo = () => {
    axios
      .get(`${BASE_URL}/v4/api/promotions/store-event`)
      .then((res: AxiosResponse<{ item: InvitationInfo }>) => {
        setInvitationInfo(res.data.item);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const visibilitychangeHandler = () => {
    if (document.visibilityState === "hidden") return;

    getInvitationInfo();
  };

  useEffect(() => {
    getInvitationInfo();

    document.addEventListener("visibilitychange", visibilitychangeHandler);

    return () => {
      document.removeEventListener("visibilitychange", visibilitychangeHandler);
    };
  }, []);

  return (
    <section className="spring-day-bride-container">
      <img src={Section1Img} alt="" className="d-block" />
      <img src={Section2Img} alt="" className="d-block" />
      <div className="section-3-wrap">
        <img src={Section3Img} alt="" className="d-block" />
        <button className="copy-link-btn" onClick={handleClickCopyLinkBtn}>
          내 청첩장 링크 복사하기
        </button>
        <button className="event-application-btn" onClick={handleClickApplyBtn}>
          이벤트 응모하기
        </button>
      </div>
      <img src={Section4Img} alt="" className="d-block" />
    </section>
  );
}
